module.exports = __webpack_public_path__ + "fonts/Roboto-Light.88823c20.ttf";